//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import checkBox from '@/components/card/checkBox';
import { removeReport, openReport } from '@/utils/report';
import tip2 from '@/components/tip2';
import { activity_api } from '@/api/api/user';

import { debounce, formatPath, replaceToOriginStr } from '@/utils/tools';
import { setting_obj } from '@/settings/setting';

export default {
  props: {},
  data() {
    return {
      openReport,
      removeReport,
      select_mark: false,
      page_size: 50,
      page_num: 1,
      total: 0,
      keyword: '',
      load_end: false,
      search_list: [],
      upload_type: '1',
      current_item: {},
      display_mode: 0,
      res_name: '',
      isShowDialog: true,
      update_res_id: '',
      result_key: '',
      doc_done: false,
      learnMoreUrl: `${window.location.origin}/help/view/cover`,
    };
  },
  components: { checkBox, tip2 },
  created() {},
  mounted() {
    window.Publish = this;
    this.initSearch();
    this.load_more = debounce(this.load_more, 100);
    this.input_change = debounce(this.input_change, 300);
    this.$sensors.track('publish_popout', {
      action_type: this.type,
      active_id: this.act_id,
      active_name: this.act_name,
    });
  },
  computed: {
    coverUrl() {
      const { cover_url } = this.current_item;
      if (cover_url) return formatPath(cover_url, setting_obj.imageCdnPath);

      return '';
    },
    disableMark() {
      return !this.res_name || !this.current_item.doc_id || this.res_name.length > 20;
    },
    noMore() {
      return this.total && this.search_list.length >= this.total;
    },
  },

  methods: {
    async upload() {
      if (this.upload_mark) {
        return false;
      }
      this.upload_mark = true;
      // if(thgis.current_item)
      if (!this.current_item.doc_id) {
        this.$message({
          message: '请选择作品',
          type: 'error',
        });
        return false;
      }
      if (!this.res_name) {
        this.$message({
          message: '请输入作品名称',
          type: 'error',
        });
        return false;
      }
      if (this.res_name.length > 20) {
        this.$message({
          message: '最多支持输入20个字符',
          type: 'error',
        });
        return false;
      }
      if (!this.res_name) {
        this.$message({
          message: '请输入作品名称',
          type: 'error',
        });
        return false;
      }
      if (this.upload_type === '2') {
        this.openReport('confirm', {
          title: '更新作品',
          message: '更新后，作品将重新进入审核流程。确认更新吗？',
          confirmFunc: () => {
            this.confirm_pro();
          },
        });
        return false;
      }
      await this.confirm_pro();
      setTimeout(() => {
        this.upload_mark = false;
      }, 500);
      return true;
    },
    async confirm_pro() {
      this.current_file = '';
      const { data } = await this.$nuxt.$axios.get(activity_api.user_doc_copy, {
        params: { doc_id: this.current_item.doc_id },
      });
      this.current_file = data?.data?.file_key;
      if (this.display_mode === 0) {
        this.upload_func();
        return false;
      }

      if (!data?.data?.proto_file) {
        this.openReport('confirm', {
          title: '上传提示',
          message: `您当前选择的作品未添加交互， 为保证更好的查看体验，我们将为您把"原型演示"展示方式调整为"设计预览"`,
          confirmFunc: () => {
            this.upload_func();
          },
        });
        this.display_mode = 0;
      } else {
        this.upload_func();
      }
      return true;
    },
    async upload_func() {
      const params = {
        doc_id: this.current_item.doc_id,
        res_name: this.res_name,
        res_desc: this.$refs.res_desc.getHtml(),
        display_mode: this.display_mode,
        cover_url: this.current_item.cover_url,
        act_id: Number(this.act_id),
        act_name: this.act_name,
        message_type: Number(this.upload_type),
        file_key: this.current_file,
      };
      if (this.upload_type === '2') {
        params.res_id = this.update_res_id;
      }
      console.log('params', params);

      try {
        const pub_res = await this.$nuxt.$axios.post(activity_api.user_doc_pub, params);
        if (pub_res.data.code === 'OK') {
          this.$message({
            message: '作品已提交，请耐心等待审核结果，预计 1-2 个工作日',
            type: 'success',
          });
        } else if (pub_res.data.code === 'BanResPub') {
          this.$message({
            message: '作品提交失败，作品提交时间已截止',
            type: 'error',
          });
        }

        removeReport('publish');
      } catch (e) {
        console.log('err', e);
        this.$message({
          message: '作品提交失败，请重试',
          type: 'error',
        });
      }
    },
    choose_type(type) {
      console.log('choose_type');
      this.display_mode = type;
    },
    async update_item(item) {
      console.log('update_item', item);
      this.select_mark = false;
      this.current_item = item;
      this.upload_type = '2';
      this.res_name = item.name;
      const res = await this.$nuxt.$axios.get(activity_api.res_info, { params: { doc_id: item.doc_id } });
      const result = res.data;
      if (result.code === 'OK' && result.data) {
        this.res_name = replaceToOriginStr(result.data.res_name);
        this.update_res_id = result.data.res_id;
        this.display_mode = result.data.display_mode;
        const node_html = replaceToOriginStr(result.data.res_desc);
        console.log('node_html', node_html);
        this.$refs.res_desc.setHtml(node_html);
        this.current_item.cover_url = result.data.cover_url;
      }
    },
    choose_item(item) {
      if (item.status === 5) {
        this.current_item = item;
        this.select_mark = false;
        this.upload_type = '1';
        this.res_name = replaceToOriginStr(item.name);
        this.select_mark = false;
      }
    },
    search_scroll() {
      this.closeTooltip()
      const dev_node = this.$refs.searchView;
      if (dev_node.scrollTop + dev_node.clientHeight + 50 > dev_node.scrollHeight) {
        if (!this.doc_done) this.load_more();
      }
    },
    async load_more() {
      const current_page = this.page_num + 1;
      const res_data = await this.initSearch(current_page);
      res_data.data = res_data.data || [];
      if (res_data.code === 'OK' && res_data.data.length) {
        this.page_num++;
      }
      console.log('res__data', res_data);
    },
    input_change(event) {
      console.log('input_change', event.target.value);
      console.log('this.keyword', this.keyword);
      this.doc_done = false;
      this.page_num = 1;
      this.initSearch();
    },
    async initSearch(page_num) {
      console.log('initSearch');
      page_num = page_num || this.page_num;
      const params = {
        keyword: this.keyword,
        page_num,
        page_size: this.page_size,
        act_id: this.act_id,
      };
      // console.log('initSearch2', reseeeeee);
      const res = await this.$nuxt.$axios.get(activity_api.user_doc_search, { params });
      const res_data = res.data;
      res_data.data = res_data.data || [];
      if (res_data.code === 'OK' && res_data.data.length) {
        if (page_num === 1) {
          this.search_list = res_data.data;
        } else {
          this.search_list = this.search_list.concat(res_data.data);
        }
      } else if (page_num === 1) {
        this.search_list = [];
      }
      this.result_key = this.keyword;
      if (res_data.meta) {
        this.total = res_data.meta?.page?.total || 0;
        if (this.search_list.length === this.total) {
          this.doc_done = true;
        }
      }
      return res.data;
    },
    search() {
    },
    open_select() {
      if (this.upload_type === '1') {
        this.select_mark = !this.select_mark;
      }
    },
    close_select() {
      this.select_mark = false;
    },
    closeTooltip() {
      const list = document.getElementsByClassName('el-tooltip__popper')
      if (list.length > 0) {
          list[list.length - 1].style.display = 'none'
      }
    }
  },
};
